import React from "react";
import "./InvoiceCalculationCard.css";

function InvoiceCalculationCard({
  billingCalculation,
  marginCalculation,
  country,
  type = "billing",
}) {
  const getCurrencySymbol = (calculationCountry) => {
    const normalizedCountry = String(country || calculationCountry || "")
      .trim()
      .toUpperCase();

    return ["USA", "UNITED STATES", "CANADA"].includes(normalizedCountry)
      ? "$"
      : "₹";
  };

  const formatCurrency = (value, calculationCountry) =>
    `${getCurrencySymbol(calculationCountry)}${Number(
      value || 0,
    ).toLocaleString("en-IN")}`;
  const formatNumber = (value) => Number(value || 0).toLocaleString("en-IN");

  if (type === "margin") {
    if (!marginCalculation) return null;

    const {
      country: calculationCountry,
      margin_percentage = 0,
      net_margin_after_referral = 0,
      referral_payout = 0,
      total_costs = 0,
      net_margin = 0,
    } = marginCalculation;

    const marginValue = Number(margin_percentage || 0);

    return (
      <div className="invoice-calculation-card">
        <div className="invoice-calculation-grid">
          <div className="invoice-calculation-item">
            <span className="invoice-calculation-label">Total Cost</span>

            <span className="invoice-calculation-value">
              {formatCurrency(total_costs, calculationCountry)}
            </span>
          </div>

          <div className="invoice-calculation-item">
            <span className="invoice-calculation-label">Revenue</span>

            <span className="invoice-calculation-value">
              {formatCurrency(marginCalculation.revenue, calculationCountry)}
            </span>
          </div>

          <div className="invoice-calculation-item">
            <span className="invoice-calculation-label">Referral Payout</span>

            <span className="invoice-calculation-value">
              {formatCurrency(referral_payout, calculationCountry)}
            </span>
          </div>

          <div className="invoice-calculation-item invoice-calculation-item--total">
            <span className="invoice-calculation-label">Net Profit</span>

            <span className="invoice-calculation-value">
              {formatCurrency(
                net_margin_after_referral || net_margin || 0,
                calculationCountry,
              )}
            </span>
          </div>
        </div>

        <div className="invoice-margin-bar-card">
          <div className="invoice-margin-bar-header">
            <span className="invoice-margin-percentage-label">Margin %</span>

            <span className="invoice-margin-status">
              Margin · {marginValue.toFixed(1)}%
            </span>
          </div>

          <div className="invoice-margin-progress">
            <div
              className="invoice-margin-progress-fill"
              style={{
                width: `${Math.min(Math.max(marginValue, 0), 100)}%`,
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  if (!billingCalculation) return null;

  const {
    annual_ctc,
    annual_base_salary,
    country: calculationCountry,
    placement_fee,
    taxes = [],
    tax_total,
    total_amount,
  } = billingCalculation;
  const normalizedCountry = String(country || calculationCountry || "")
    .trim()
    .toUpperCase();
  const isUSACanada = ["USA", "UNITED STATES", "CANADA"].includes(
    normalizedCountry,
  );
  const salaryLabel = isUSACanada ? "Annual Base Salary" : "Annual CTC";
  const salaryValue = isUSACanada ? annual_base_salary : annual_ctc;

  return (
    <div className="invoice-calculation-card">
      <div className="invoice-calculation-grid">
        {salaryValue && (
          <div className="invoice-calculation-item">
            <span className="invoice-calculation-label">{salaryLabel}</span>
            <span className="invoice-calculation-value">
              {formatCurrency(salaryValue, calculationCountry)}
            </span>
          </div>
        )}

        <div className="invoice-calculation-item">
          <span className="invoice-calculation-label">Placement Fee</span>

          <span className="invoice-calculation-value">
            {formatCurrency(placement_fee, calculationCountry)}
          </span>
        </div>

        {taxes.map((tax, index) => (
          <div
            className="invoice-calculation-item"
            key={`${tax.tax_type}-${index}`}
          >
            <span className="invoice-calculation-label">
              {tax.tax_type} (%)
            </span>

            <span className="invoice-calculation-value">
              {formatNumber(tax.tax_value)}
            </span>
          </div>
        ))}

        <div className="invoice-calculation-item">
          <span className="invoice-calculation-label">Tax Total</span>

          <span className="invoice-calculation-value">
            {formatCurrency(tax_total, calculationCountry)}
          </span>
        </div>

        <div className="invoice-calculation-item invoice-calculation-item--total">
          <span className="invoice-calculation-label">Total Invoice</span>

          <span className="invoice-calculation-value">
            {formatCurrency(total_amount, calculationCountry)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default InvoiceCalculationCard;
